/** Helpers for the Vimeo-hosted source films behind the work frames. */

export function vimeoPageUrl(id: string) {
  return `https://vimeo.com/${id}`;
}

/** Silent, chrome-free loop used for the card previews. */
export function vimeoLoopUrl(id: string) {
  return `https://player.vimeo.com/video/${id}?background=1&autoplay=1&loop=1&muted=1&autopause=0&dnt=1`;
}

/** Full player with Vimeo's own transport, used inside the viewer dialog. */
export function vimeoPlayerUrl(id: string) {
  return `https://player.vimeo.com/video/${id}?autoplay=1&title=0&byline=0&portrait=0&dnt=1`;
}

/** Vimeo's oEmbed endpoint is CORS-enabled, so the real poster frame can be read at runtime. */
export function vimeoThumbnailEndpoint(id: string) {
  return `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(vimeoPageUrl(id))}&width=1280`;
}
